import { useLocation, useMatch } from "react-router-dom";
import { list1Routes, list1RoutesCombined } from "./ListAndDetailSamplesMultipleListsNavigation";
import { useEffect, useState } from "react";
import { list1Data, List1ItemDto } from "./ListItemDto";
import { PageContainer } from '../../../shared/PageContainer';
import ListIcon from '@mui/icons-material/List';
import { ListAndDetail } from "@sis/react-library";
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSamplesMultipleListsPageInfo } from "./ListAndDetailSamplesMultipleListsPageInfo";

export const ListAndDetailSamplesMultipleListsPage = () => {

  const matchEdit = useMatch(list1RoutesCombined().list_editMatch);
  const location = useLocation();

  // Used to collapse list when second list selected
  const [fireCollapse, setFireCollapse] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    // If the user has clicked second list, collapse this one
    if (matchEdit === null && !location.pathname.includes(list1Routes.new)) {
      setFireCollapse(true);
    }
    // We only want for matchEdit
    // eslint-disable-next-line
  }, [matchEdit])

  useEffect(() => {
    // Once fireCollapse is triggered, set it back to undefined
    if (fireCollapse !== undefined) {
      setFireCollapse(undefined);
    }
  }, [fireCollapse])

  const list1ItemRender = (item: List1ItemDto) => <>{item.description}</>;

  return (
    <PageContainer
      heading='List Samples - Multiple Lists'
      icon={<ListIcon />}
      pageInfo={<ListAndDetailSamplesMultipleListsPageInfo />}
      wrapRightElementForMobile={false}
    >
      <ListAndDetail
        id="list1"
        items={list1Data}
        keyValue={(item) => item.code1}
        itemRender={list1ItemRender}
        searchFields={['description']}
        listUrl={listAndDetailSamplesRoutes.multipleLists}
        newUrl={list1Routes.new}
        editUrl={list1Routes.edit}
        fireCollapse={fireCollapse}
      />
    </PageContainer>
  )
}
